import screenfull from 'screenfull';
let fullscreen_btn_elem = document.querySelector('.fullscreen-btn');
let fullscreen_on_svg = '<svg id="fullscreen-on" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z"/></svg>';
let fullscreen_off_svg = '<svg id="fullscreen-off" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"/><path d="M18 7h4v2h-6V3h2v4zM8 9H2V7h4V3h2v6zm10 8v4h-2v-6h6v2h-4zM8 15v6H6v-4H2v-2h6z"/></g></svg>';
setFullscreenBtnVisibility();

document.onfullscreenchange = setFullscreenBtnVisibility;

document.querySelector('.fullscreen-btn').onclick = () => {
	if (screenfull.isEnabled) {
		screenfull.toggle();
	} else {
		// Ignore or do something else
	}
};

function setFullscreenBtnVisibility() {
    if(screenfull.isFullscreen) {
        fullscreen_btn_elem.innerHTML = fullscreen_off_svg;
    }else {
        fullscreen_btn_elem.innerHTML = fullscreen_on_svg;
    }
}